import { render, staticRenderFns } from "./ConfirmRegionDelete.vue?vue&type=template&id=0f35587e&scoped=true"
import script from "./ConfirmRegionDelete.vue?vue&type=script&lang=js"
export * from "./ConfirmRegionDelete.vue?vue&type=script&lang=js"
import style0 from "./ConfirmRegionDelete.vue?vue&type=style&index=0&id=0f35587e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f35587e",
  null
  
)

export default component.exports